module.exports = "/assets/pattern-rw-tile@2x.png?Tihrz6j";